var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-form" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "destroy-on-close": "",
            width: "500px",
            "custom-class": "custom-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.formLoading },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v("确 定")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "竞品平台：", prop: "platform" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.formData.platform,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "platform", $$v)
                        },
                        expression: "formData.platform",
                      },
                    },
                    _vm._l(_vm.platformIdsOptions, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "竞品商品名称：", prop: "productName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入竞品商品名称（限200个字符）",
                      maxlength: "200",
                      type: "textarea",
                      autosize: { minRows: 1, maxRows: 2 },
                    },
                    model: {
                      value: _vm.formData.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "productName", $$v)
                      },
                      expression: "formData.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "竞品商品规格：", prop: "specName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入竞品商品规格（限200个字符）",
                      maxlength: "200",
                      type: "textarea",
                      autosize: { minRows: 1, maxRows: 2 },
                    },
                    model: {
                      value: _vm.formData.specName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "specName", $$v)
                      },
                      expression: "formData.specName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "竞品URL地址：", prop: "url" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入竞品URL地址（限500个字符）",
                      maxlength: "500",
                      type: "textarea",
                      autosize: { minRows: 1, maxRows: 2 },
                    },
                    model: {
                      value: _vm.formData.url,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "url", $$v)
                      },
                      expression: "formData.url",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }